import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "yotiModalConfirmation" */ './YotiModalConfirmation')),
);

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'YotiModalConfirmation');

export default LazyComponentWithSuspense;
